<template lang="pug">
  #container
    el-button(
      @click="handleClick('btn-0')"
      :class="{selecionado: btnCondicao}"
    ) {{botao0}}
    el-button(
      @click="handleClick('btn-1')"
      :class="{selecionado: !btnCondicao}"
    ) {{botao1}}
</template>

<script>
export default {
  name: 'BotaoSelecionar',
  props: {
    botao0: {
      type: String,
      required: true
    },
    botao1: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      btnCondicao: true
    }
  },
  methods: {
    handleClick (btn) {
      if (btn === 'btn-0') {
        this.$emit('btn-0')
        this.btnCondicao = true
      } else if (btn === 'btn-1') {
        this.$emit('btn-1')
        this.btnCondicao = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  /deep/ .el-button {
    margin: 0;
    border-color: #c3c3c3;

    &.selecionado {
      background: #009f61;
      border: 0;
      color: #FFFFFF;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/BotaoSelecionar.vue